// The dashboard pages listed on /dashboards, alphabetical by title.
//
// They used to sit in Home's own ALL_PAGES; they were moved here on 2026-09-26
// so the two pages cannot drift apart. Home now carries one "Dashboards" card
// in their place. Each entry is the same shape Home uses: {path, title,
// description, icon}.
//
// The Town–School Memorandum of Agreement is here too. It is not built on the
// accordion pattern the others share (see CLAUDE.md), but it is a plan page and
// belongs with them in the directory.
export const DASHBOARD_PAGES = [
  {
    path: '/roadmap-2030',
    title: '2030 Roadmap',
    description: 'Select Board strategic priorities - goals, strategies and actions through 2030',
    icon: '🗺️',
  },
  {
    path: '/athletic-fields',
    title: 'Athletic Fields Master Plan',
    description: '2020 Athletic Fields Needs Assessment and Master Plan - recommendations and action plan',
    icon: '🏟️',
  },
  {
    path: '/carp-2026',
    title: 'CARP 2026',
    description: 'Climate Action and Resiliency Plan - goals, strategies and actions through 2036',
    icon: '🌍',
  },
  {
    path: '/community-health-plan',
    title: 'Community Health Improvement Plan',
    description: '2024–2028 Community Health Improvement Plan - goals, objectives and strategies across four health priority areas',
    icon: '🏥',
  },
  {
    path: '/dpw-strategic-plan',
    title: 'DPW Strategic Plan',
    description: 'Department of Public Works 2022–2032 Strategic Plan - five guiding principles, objectives and action items',
    icon: '🛠️',
  },
  {
    path: '/ersc-recommendations',
    title: 'Expenditures & Revenues Study Committee Recommendations',
    description: 'Enumerated recommendations with status tracking',
    icon: '💼',
  },
  {
    path: '/hazard-mitigation',
    title: 'Hazard Mitigation Plan',
    description: '2023 Hazard Mitigation Plan - 59 mitigation actions by priority, hazard and implementation schedule',
    icon: '⚠️',
  },
  {
    path: '/housing-production-plan',
    title: 'Housing Production Plan',
    description: '2024 Housing Production Plan - housing goals and regulatory, policy and advocacy strategies',
    icon: '🏘️',
  },
  {
    path: '/open-space',
    title: 'Open Space & Recreation Plan',
    description: 'Open Space and Recreation Plan 2025 - goals, objectives and a ten-year action plan',
    icon: '🏞️',
  },
  {
    path: '/town-school-moa',
    title: 'Town–School Memorandum of Agreement',
    description: 'March 2026 Memorandum of Agreement between the Town and the Schools - ten goals and who is responsible for each',
    icon: '🤝',
  },
  {
    path: '/urban-forestry',
    title: 'Urban Forestry Master Plan',
    description: 'Urban Forest Climate Resiliency Master Plan - goals, objectives and actions, cross-referenced to the CARP',
    icon: '🌳',
  },
  {
    path: '/vision-zero',
    title: 'Vision Zero Action Plan',
    description: 'Vision Zero Action Plan - 28 strategies to end traffic deaths and serious injuries by 2035',
    icon: '🚦',
  },
];
